import { useState, useEffect, useRef } from 'react';
import { clientiApi } from '../api';

export default function ClienteAutocomplete({ value, onChange, onSelect, placeholder = 'Ragione Sociale *', className = 'input' }) {
  const [suggestions, setSuggestions] = useState([]);
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const handleChange = async (e) => {
    const val = e.target.value;
    onChange(val);
    if (val.length < 2) { setSuggestions([]); setOpen(false); return; }
    try {
      const results = await clientiApi.list({ search: val });
      setSuggestions(results.slice(0, 8));
      setOpen(results.length > 0);
    } catch { setSuggestions([]); setOpen(false); }
  };

  const select = (c) => {
    onSelect(c);
    setSuggestions([]);
    setOpen(false);
  };

  return (
    <div className="relative" ref={ref}>
      <input
        className={className}
        value={value}
        onChange={handleChange}
        onFocus={() => suggestions.length > 0 && setOpen(true)}
        placeholder={placeholder}
        autoComplete="off"
      />
      {open && (
        <ul className="absolute z-50 w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-lg max-h-52 overflow-y-auto">
          {suggestions.map(c => (
            <li
              key={c.id}
              className="px-3 py-2 hover:bg-brand-50 cursor-pointer text-sm border-b last:border-0"
              onMouseDown={() => select(c)}
            >
              <div className="font-medium text-gray-800">{c.ragione_sociale || c.nome}</div>
              {c.ragione_sociale && c.nome && c.ragione_sociale !== c.nome && (
                <div className="text-xs text-gray-400">{c.nome}</div>
              )}
              {c.piva && <div className="text-xs text-gray-400">P.IVA {c.piva}</div>}
            </li>
          ))}
          <li className="px-3 py-2 text-xs text-gray-400 italic">
            Seleziona un esistente o continua a digitare per crearne uno nuovo
          </li>
        </ul>
      )}
    </div>
  );
}
